import mojs from '@mojs/core'
import Noty from 'noty'
import 'noty/lib/noty.css'
import '@/styles/lorin.scss'

const notification = {
  preset: {
    type: 'success',
    theme: 'lorin',
    timeout: 3 * 1000,
    layout: 'topCenter',
    animation: {
      open: function (promise) {
        const n = this
        const Timeline = new mojs.Timeline()
        const body = new mojs.Html({
          el: n.barDom,
          x: { 500: 0, delay: 0, duration: 500, easing: 'elastic.out' },
          isForce3d: true,
          onComplete: function () {
            promise(function (resolve) {
              resolve()
            })
          }
        })

        const parent = new mojs.Shape({
          parent: n.barDom,
          width: 200,
          height: n.barDom.getBoundingClientRect().height,
          radius: 0,
          x: { 150: -150 },
          duration: 1.2 * 500,
          isShowStart: true
        })

        n.barDom.style.overflow = 'visible'
        parent.el.style.overflow = 'hidden'

        const burst = new mojs.Burst({
          parent: parent.el,
          count: 10,
          top: n.barDom.getBoundingClientRect().height + 75,
          degree: 90,
          radius: 75,
          angle: { [-90]: 40 },
          children: {
            fill: '#ffffff',
            delay: 'stagger(500, -50)',
            radius: 'rand(8, 25)',
            direction: -1,
            isSwirl: true
          }
        })

        const fadeBurst = new mojs.Burst({
          parent: parent.el,
          count: 2,
          degree: 0,
          angle: 75,
          radius: { 0: 100 },
          top: '90%',
          children: {
            fill: '#ffffff',
            pathScale: [0.65, 1],
            radius: 'rand(12, 15)',
            direction: [-1, 1],
            delay: 0.8 * 500,
            isSwirl: true
          }
        })

        Timeline.add(body, burst, fadeBurst, parent)
        Timeline.play()
      },
      close: function (promise) {
        const n = this
        new mojs.Html({
          el: n.barDom,
          x: { 0: 5000, delay: 10, duration: 500, easing: 'elastic.in' },
          isForce3d: true,
          onComplete: function () {
            promise(function (resolve) {
              resolve()
            })
          }
        }).play()
      }
    }
  },

  /**
   * success
   *
   * @param text
   */
  success (text) {
    this.notify(text)
  },

  /**
   * error
   *
   * @param text
   */
  error (text) {
    this.notify(text, 'error')
  },

  /**
   * alert
   *
   * @param text
   */
  alert (text) {
    this.notify(text, 'alert')
  },

  /**
   * warning
   *
   * @param text
   */
  warning (text) {
    this.notify(text, 'warning')
  },

  /**
   * info
   *
   * @param text
   */
  info (text) {
    this.notify(text, 'info')
  },

  /**
   * 快速通知
   *
   * @param text
   * @param type
   */
  notify (text, type = 'success') {
    const custom = {
      type,
      text
    }

    const options = _.assign({}, this.preset, custom)

    this.raw(options)
  },

  /**
   * Noty原生方法
   *
   * @param options
   */
  raw (options) {
    new Noty(options).show()
  }
}

export default notification
